import { sanitizeHtml } from '../../../../utils'
import { CityDesc, CityInfo, CityPhoto } from './style'


export const CitySectionComponent = ({ description, imageUrl, altText }) => {
	return (
			<CityInfo>
				<CityDesc dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }} />
				<CityPhoto> 
					<img src={imageUrl} alt={altText} />
				</CityPhoto>
			</CityInfo>
	)

}